import { DeviceManifest } from '@rapoo/device-sdk'
import {
  dpi60kStep1,
  mouseMacro,
  mousePerfCap,
  mouseRtVT2,
  retailMouseConfig,
} from './generate/capabilityPresets'

/**
 * VT2 RT MASTER 设备清单
 **/
const rapooVT2RTMATSERV2: DeviceManifest = {
  channel: ['china_game', 'global'],
  model: 'VT2 RT MASTER V2',
  mainControl: 'VT2 RT MASTER V2',
  dongleModel: 'Dongle_NordicLM20',
  type: 'mouse',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4b21, 0x1b21],
    pairingProductIds: [0x145a],
    currentPid: 0x4b21,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 14,
        description: 'Only update Firmware',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Only update WCH Firmware',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'LM20RT',
  MCU: 'N54LM20',
  sensor: 'PAW3955U',
  microSwitch: 'optical',
  encoder: 'optical',
  battery: 300,
  ui: {
    assetsDir: 'manifests/VT2 RT MASTER V2',
    colors: {
      series: [
        {
          name: 'common.products.VT2_RT_MASTER_V2.First_Light',
          value: '#312F2F',
          key: 'First_Light',
        },
        {
          name: 'common.products.VT2_RT_MASTER_V2.Night_Erosion',
          value: '#FF6CB6',
          key: 'Night_Erosion',
        },
        {
          name: 'common.products.VT2_RT_MASTER_V2.Void',
          value: '#828282',
          key: 'Void',
        },
      ],
      current: 'First_Light',
    },
    icon: 'Hardware-Wireframe-Mouse',
    // 是否支持设备概览
    overview: true,
  },
  capabilities: [
    retailMouseConfig,
    {
      type: 'parameters',
      config: {
        liftoffHeight: [0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7],
        keyDebounce: {
          displayPage: 'rt',
        },
      },
    },
    dpi60kStep1,
    mouseMacro,
    mouseRtVT2,
    mousePerfCap({
      tier: 'retail',
      sensorScanRateLabel: '13K',
      keyScanRate: true,
      rfPacketType: 'always',
    }),
  ],
  layout: {
    keys: [
      [
        { key: 0, keywords: '左击', x: -25, y: 50, alignLeft: false, url: 'mouse left' },
        { key: 1, keywords: '中键', x: 240, y: 100, alignLeft: true, url: 'roller middle' },
        { key: 2, keywords: '右击', x: 240, y: 50, alignLeft: true, url: 'mouse right' },
        { key: 5, keywords: '右侧', x: -25, y: 132, alignLeft: false, url: 'mouse forward' },
        { key: 6, keywords: '左侧', x: -25, y: 195, alignLeft: false, url: 'mouse back' },
        { key: 9, keywords: '上滚', x: 240, y: 150, alignLeft: true, url: 'roller up' },
        { key: 10, keywords: '下滚', x: 240, y: 200, alignLeft: true, url: 'roller down' },
        { key: 13, keywords: 'DIY', x: 655, y: 118, alignLeft: true, url: 'diy' },
      ],
    ],
  },
}

export default rapooVT2RTMATSERV2
